import { useSession } from '@/stores/session';

export function AccountPage() {
  const user = useSession((s) => s.user)!;
  return (
    <div className="max-w-2xl space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-moss-200">Mi cuenta</h1>
        <p className="mt-1 text-sm text-moss-300/70">Datos básicos de tu sesión.</p>
      </div>
      <div className="glass-card p-6">
        <Row label="Email" value={user.email} />
        <Row label="Rol" value={user.role} />
        <Row label="ID" value={user.id} />
      </div>
      <p className="text-xs text-moss-300/60">
        El cambio de contraseña self-service llegará en una próxima iteración. Por ahora pídele al
        admin que actualice tu password en{' '}
        <code className="text-mustard-300">/usuarios</code>.
      </p>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center justify-between border-b border-ink-700/50 py-3 last:border-0">
      <span className="text-xs uppercase tracking-wide text-moss-300/70">{label}</span>
      <span className="font-mono text-sm text-moss-200">{value}</span>
    </div>
  );
}
